import CheckIcon from '@material-ui/icons/Check';
export default CheckIcon;
